module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"profile":{"description":{"action":"Beschreibung hinzufügen","empty_state":"Fügen Sie Ihrem Profil eine Beschreibung hinzu, damit die Community Sie besser kennenlernen kann. Beschreiben Sie zum Beispiel Ihre Anlagestrategien, die Art der Beratung die Sie anbieten oder was Ihnen dabei wichtig ist.","title":"Meine Investmentphilosophie"}}}}}}}')
  delete Component.options._Ctor
}
